import {
  ONBOARDING_SLIDE_MESSAGE_GET_SUCCESS, ONBOARDING_SLIDE_MESSAGE_GET_FAILURE,
} from '../actions/types';
import config from '../configs';

const initialState = {
  config,
  defaults: {
    data: {},
    isLoading: false,
    isLoaded: false,
  },
};

export default (state = initialState, action) => {
  const namespaceId = action?.options?.namespace || action?.context?.options?.namespace || 'default';
  const namespace = `namespace-${namespaceId}`;
  const { defaults } = state;
  const { [namespace]: namespaceState = defaults } = state;

  switch (action.type) {
    case ONBOARDING_SLIDE_MESSAGE_GET_SUCCESS: {
      const { assets = {}, termsAndConditions } = action.payload.response[0] || {};
      const { preHeadline, shortSummaryText } = assets;

      return {
        ...state,
        [namespace]: {
          ...namespaceState,
          data: {
            disclaimer: termsAndConditions,
            preTitle: preHeadline,
            title: shortSummaryText,
          },
          isLoading: false,
          isLoaded: true,
        },
      };
    }
    case ONBOARDING_SLIDE_MESSAGE_GET_FAILURE: {
      return {
        ...state,
        [namespace]: {
          ...namespaceState,
          data: [],
          isLoading: false,
          isLoaded: true,
        },
      };
    }
    default: {
      const { options = {} } = action;
      if (options.success === ONBOARDING_SLIDE_MESSAGE_GET_SUCCESS) {
        return {
          ...state,
          [namespace]: {
            ...namespaceState,
            isLoading: true,
          },
        };
      }

      return state;
    }
  }
};
